import React, { useState } from 'react';

/**
 * Directional arrow component that displays → for LTR and ← for RTL
 */
function DirectionalArrow() {
  // Lazy initialization - function only runs on first render
  const [isRTL] = useState(
    () => getComputedStyle(document.documentElement).direction === 'rtl'
  );

  return (
    <span aria-hidden='true'>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      {isRTL ? '\u2190' : '\u2192'}
    </span>
  );
}

export default DirectionalArrow;
